import { useStrictLocalization } from "@faire/web--source/common/localization";

export const useLoggedOutRetailerNodes = () => {
  const { strictLocalize } = useStrictLocalization();
  const loggedOutRetailerNodes = {
    L1: {
      Account: strictLocalize({
        defaultMessage: "Account settings (e.g. update address)",
        description: { text: "Type of issue for a help center ticket" },
      }),
      HowFaireWork: strictLocalize({
        defaultMessage: "How does Faire work",
        description: { text: "Type of issue for a help center ticket" },
      }),
      Invoices: strictLocalize({
        defaultMessage: "Invoices and payments",
        description: { text: "Type of issue for a help center ticket" },
      }),
      Items: strictLocalize({
        defaultMessage: "Missing and damaged items",
        description: { text: "Type of issue for a help center ticket" },
      }),
      Orders: strictLocalize({
        defaultMessage: "Order status",
        description: { text: "Type of issue for a help center ticket" },
      }),
      Returns: strictLocalize({
        defaultMessage: "Returns and refunds",
        description: { text: "Type of issue for a help center ticket" },
      }),
      GeneralShipping: strictLocalize({
        defaultMessage: "General shipping questions",
        description: {
          text: "Type of issue for a help center article",
        },
      }),
      Other: strictLocalize({
        defaultMessage: "Other Retailer Issues",
        description: { text: "Type of issue for a help center ticket" },
      }),
    },
    L2: {
      ImportFeesAndDuties: strictLocalize({
        defaultMessage: "Import fees & Duties",
        description: {
          text: "Type of issue for a help center article",
        },
      }),
      BuyingInternational: strictLocalize({
        defaultMessage: "Buying International",
        description: {
          text: "Type of issue for a help center article",
        },
      }),
      Other: strictLocalize({
        defaultMessage: "Other",
        description: {
          text: "Type of issue for a help center article",
        },
      }),
    },
  };
  return loggedOutRetailerNodes;
};
